module.exports = __webpack_public_path__ + "static/media/Icon-VertMenu.3dc9c6f2.svg";